import _ from 'lodash';

export const pennyPrecisionFuncMap = {
  ceiling: (val) => {
    return _.ceil(val, 2);
  },
  floor: (val) => {
    return _.floor(val, 2);
  },
};
const getPennyPrecisionFunc = (pennyPrecisionFuncKey) => {
  return pennyPrecisionFuncMap[pennyPrecisionFuncKey];
};
export default getPennyPrecisionFunc;
